<div class="tp-studio">
  <header class="tp-hero">
    <div class="tp-hero__icon"><mat-icon>percent</mat-icon></div>
    <div class="tp-hero__text">
      <span class="tp-hero__eyebrow">Cartera · Simulador</span>
      <h1 class="tp-hero__title">Tasas Preferenciales</h1>
      <p class="tp-hero__subtitle">Configura la tasa y el seguro de cada política y simula cómo quedan las cuotas.</p>
    </div>
    <div class="tp-hero__stats">
      <div class="tp-stat">
        <span class="tp-stat__value">{{ politica.length }}</span>
        <span class="tp-stat__label">{{ politica.length === 1 ? 'política' : 'políticas' }}</span>
      </div>
      <div class="tp-stat">
        <span class="tp-stat__value">{{ plazos.length }}</span>
        <span class="tp-stat__label tp-stat__label--nowrap">{{ plazos.length === 1 ? 'plazo disponible' : 'plazos disponibles' }}</span>
      </div>
    </div>
  </header>

  <div class="tp-studio__grid">
    <!-- 1. Configuración -->
    <section class="tp-card tp-card--config">
      <div class="tp-card__head">
        <span class="tp-step">1</span>
        <div>
          <h2>Configura</h2>
          <span class="tp-card__hint">Define tasa, seguro y plazos de la política</span>
        </div>
      </div>

      <mat-form-field appearance="outline" class="tp-field">
        <mat-label>Política</mat-label>
        <mat-select [(ngModel)]="selectedPolitica" placeholder="Seleccionar política">
          <mat-option *ngFor="let item of politica" [value]="item['CODIGO']">
            {{ item['NOM_PARAM'] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="tp-row">
        <mat-form-field appearance="outline" class="tp-field tp-field--num">
          <mat-label>Tasa efectiva anual</mat-label>
          <input matInput type="text" inputmode="decimal"
                 [(ngModel)]="tasa"
                 (blur)="tasa = sinSimbolo(formatTasa(tasa))">
          <span matSuffix class="tp-affix">%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="tp-field tp-field--num">
          <mat-label>Seguro</mat-label>
          <span matPrefix class="tp-affix">$&nbsp;</span>
          <input matInput type="text" inputmode="decimal"
                 [(ngModel)]="seguro"
                 (blur)="seguro = sinSimbolo(formatSeguro(seguro))">
        </mat-form-field>
      </div>

      <div class="tp-plazos">
        <div class="tp-plazos__head">
          <span class="tp-label">
            Plazos
            <span class="tp-count" *ngIf="plazos.length">{{ plazosSeleccionados().length }} / {{ plazos.length }}</span>
          </span>
          <button type="button" class="tp-link" (click)="toggleTodos()" [disabled]="!plazos.length">
            {{ allSelected() ? 'Quitar todos' : 'Todos' }}
          </button>
        </div>
        <div class="tp-chips" *ngIf="plazos.length; else sinPlazos">
          <button type="button" *ngFor="let plazo of plazos"
                  class="tp-chip" [class.tp-chip--on]="plazo.selected"
                  (click)="plazo.selected = !plazo.selected">
            <mat-icon *ngIf="plazo.selected">check</mat-icon>
            {{ plazo.name }}
          </button>
        </div>
        <ng-template #sinPlazos>
          <p class="tp-muted">No hay plazos disponibles.</p>
        </ng-template>
      </div>

      <div class="tp-summary" [class.tp-summary--ready]="listoParaGuardar()">
        <span class="tp-summary__label">
          <mat-icon>{{ listoParaGuardar() ? 'task_alt' : 'pending' }}</mat-icon>
          Vas a guardar
        </span>
        <span class="tp-summary__politica">{{ nombrePolitica() || 'Sin política seleccionada' }}</span>
        <div class="tp-summary__pills">
          <span class="tp-pill">Tasa <b>{{ tasa || 0 }}%</b></span>
          <span class="tp-pill">Seguro <b>${{ seguro || 0 }}</b></span>
          <span class="tp-pill">
            <b>{{ plazosSeleccionados().length }}</b> {{ plazosSeleccionados().length === 1 ? 'plazo' : 'plazos' }}
          </span>
        </div>
      </div>

      <button mat-flat-button type="button" class="tp-btn tp-btn--primary tp-btn--block" (click)="onSubmit()">
        <mat-icon>save</mat-icon>
        Guardar configuración
      </button>
    </section>

    <!-- 2. Simulación -->
    <section class="tp-card tp-card--sim">
      <div class="tp-card__head">
        <span class="tp-step tp-step--dark">2</span>
        <div>
          <h2>Simula</h2>
          <span class="tp-card__hint">Usa la configuración guardada de la política</span>
        </div>
      </div>

      <form [formGroup]="tasaForm" class="tp-sim-form" (ngSubmit)="simular()">
        <mat-form-field appearance="outline" class="tp-field">
          <mat-label>Capital</mat-label>
          <input matInput type="text" inputmode="numeric"
                 formControlName="capital"
                 [(ngModel)]="capital"
                 (ngModelChange)="onCapitalChange($event)"
                 [value]="formatSeguro(capital)">
        </mat-form-field>
        <button mat-flat-button type="submit" class="tp-btn tp-btn--primary tp-btn--square" aria-label="Simular">
          <mat-icon>play_arrow</mat-icon>
        </button>
      </form>

      <ng-container *ngIf="resultados.length; else sinResultados">
        <div class="tp-highlight" *ngIf="destacado as d">
          <div class="tp-highlight__top">
            <span class="tp-highlight__cuotas">{{ d.cuotas }} cuotas</span>
            <span class="tp-badge" *ngIf="d === menorCosto()">Menor costo total</span>
          </div>
          <div class="tp-highlight__amount">
            {{ d.valorCuota | currency:'USD':'symbol':'1.0-0' }}<small>/ mes</small>
          </div>
          <div class="tp-highlight__meta">
            <span>Intereses <b>{{ d.intereses | currency:'USD':'symbol':'1.0-0' }}</b></span>
            <span>Seguro total <b>{{ d.totalSeguro | currency:'USD':'symbol':'1.0-0' }}</b></span>
            <span>Tasa <b>{{ d.tasa }}%</b></span>
          </div>
        </div>

        <div class="tp-bars" aria-label="Valor full por plazo">
          <button type="button" *ngFor="let r of resultados" class="tp-bar"
                  [class.tp-bar--on]="r === destacado" (click)="destacado = r"
                  [matTooltip]="(r.full | currency:'USD':'symbol':'1.0-0') + ' en ' + r.cuotas + ' cuotas'">
            <span class="tp-bar__fill" [style.height.%]="alturaBarra(r)"></span>
            <span class="tp-bar__label">{{ r.cuotas }}</span>
          </button>
        </div>

        <div class="tp-table-wrap">
          <table class="tp-table">
            <thead>
              <tr>
                <th>Cuotas</th>
                <th>Valor cuota</th>
                <th>Intereses</th>
                <th>Seguro total</th>
                <th>Financiado</th>
                <th>Valor full</th>
                <th>Tasa</th>
                <th>Seguro</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of resultados" [class.tp-row--on]="r === destacado" (click)="destacado = r">
                <td>{{ r.cuotas }}</td>
                <td>{{ r.valorCuota | currency:'USD':'symbol':'1.0-0' }}</td>
                <td>{{ r.intereses | currency:'USD':'symbol':'1.0-0' }}</td>
                <td>{{ r.totalSeguro | currency:'USD':'symbol':'1.0-0' }}</td>
                <td>{{ r.financiado | currency:'USD':'symbol':'1.0-0' }}</td>
                <td>{{ r.full | currency:'USD':'symbol':'1.0-0' }}</td>
                <td>{{ r.tasa }}%</td>
                <td>{{ r.seguro | currency:'USD':'symbol':'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #sinResultados>
        <div class="tp-empty">
          <div class="tp-empty__icon"><mat-icon>insights</mat-icon></div>
          <p *ngIf="!selectedPolitica">Elige una política para empezar.</p>
          <p *ngIf="selectedPolitica">Ingresa un capital y presiona simular.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
